"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _clsx3 = _interopRequireDefault(require("clsx"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _de = _interopRequireDefault(require("../../../locals/de.json"));
var _en = _interopRequireDefault(require("../../../locals/en.json"));
var _it = _interopRequireDefault(require("../../../locals/it.json"));
var _ProductTeaser = _interopRequireDefault(require("../../../components/ProductTeaser"));
var _List = _interopRequireDefault(require("./List.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Alert = (0, _component.default)(function () {
  return import("@material-ui/lab/Alert");
});
var Pagination = (0, _component.default)(function () {
  return import("@material-ui/lab/Pagination");
});
var List = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _clsx;
  var currentPage = _ref.currentPage,
    displayedFeatures = _ref.displayedFeatures,
    _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    itemsCounter = _ref.itemsCounter,
    itemsPerPage = _ref.itemsPerPage,
    lang = _ref.lang,
    loading = _ref.loading,
    productTeaserComponent = _ref.productTeaserComponent,
    showAttributes = _ref.showAttributes,
    showBookmark = _ref.showBookmark,
    showCategories = _ref.showCategories,
    showFilter = _ref.showFilter,
    onPaginate = _ref.onPaginate;
  var css = (0, _List.default)();
  var l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  var hasItems = (0, _react.useMemo)(function () {
    return !!(items !== null && items !== void 0 && items.length);
  }, [items]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx3.default)(css.listWrapper, "mco-shop-product-overview-list-wrapper", (_clsx = {}, _defineProperty(_clsx, css.listWrapperNoFilter, !showFilter), _defineProperty(_clsx, "mco-shop-product-overview-list-wrapper--no-filter", !showFilter), _clsx))
  }, hasItems && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx3.default)(css.list, "mco-shop-product-overview-list", _defineProperty({}, css.largeList, !showCategories)),
    ref: ref
  }, items === null || items === void 0 ? void 0 : items.map(function (product) {
    var combinationID = product.combinationID,
      id = product.id;
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: "".concat(id, "-").concat(combinationID)
    }, productTeaserComponent ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.cloneElement(productTeaserComponent, {
      displayedFeatures: displayedFeatures,
      lang: lang,
      product: product,
      showAttributes: showAttributes,
      showBookmark: showBookmark
    })) : /*#__PURE__*/_react.default.createElement(_ProductTeaser.default, {
      displayedFeatures: displayedFeatures,
      lang: lang,
      product: product,
      showAttributes: showAttributes,
      showBookmark: showBookmark
    }));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx3.default)(css.pagination, "mco-shop-product-overview-pagination")
  }, /*#__PURE__*/_react.default.createElement(Pagination, {
    count: Math.ceil(itemsCounter / itemsPerPage),
    onChange: onPaginate,
    page: currentPage
  }))), !hasItems && !loading && /*#__PURE__*/_react.default.createElement(Alert, {
    severity: "error",
    className: (0, _clsx3.default)(css.noResult, "mco-shop-product-overview__no-result")
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.messages.errors.PRODUCTS_NO_ITEMS",
    l: l
  })));
});
var _default = List;
exports.default = _default;